import Api from './../api'

export default DataLayer => DataLayer.$extend('versions', {
    get() {
        return Api.versions.get()
    },
})
